var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 628,
    height: 1018,
    viewBox: "0 0 628 1018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M599 968.5C599 979.8 589.5 989.2 578 989.2H50C38.6 989.2 29 979.8 29 968.5V49.5C29 38.2 38.5 28.8 50 28.8H578C589.4 28.8 599 38.2 599 49.5V968.5Z",
    stroke: "#fff",
    strokeWidth: 56.2796,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M496.3 885.7H160V915.8H496.3V885.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M404.3 102.2H224V128.4H404.3V102.2Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefon2);
export default __webpack_public_path__ + "static/media/telefon2.f0640781554d598774787318988341a9.svg";
export { ForwardRef as ReactComponent };